/// <amd-module name="VSSUI/Accordion" />
export { Accordion } from "./Components/Accordion/Accordion";

export { IAccordionSection, IAccordionProps } from "./Components/Accordion/Accordion.Props";
